/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './debit-note.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
import * as i8 from '../../../../../$$_gendir/node_modules/@covalent/core/steps/steps.component.ngfactory';
import * as i9 from '@covalent/core/steps/steps.component';
import * as i10 from '../../../../../$$_gendir/node_modules/@covalent/core/steps/step.component.ngfactory';
import * as i11 from '@covalent/core/steps/step.component';
import * as i12 from '@angular/forms';
import * as i13 from '@angular/flex-layout/flexbox/api/flex';
import * as i14 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i15 from '@angular/common';
import * as i16 from '@angular/platform-browser';
import * as i17 from '@angular/router';
import * as i18 from '../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-row/data-table-row.component.ngfactory';
import * as i19 from '@covalent/core/data-table/data-table-row/data-table-row.component';
import * as i20 from '../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-cell/data-table-cell.component.ngfactory';
import * as i21 from '@covalent/core/data-table/data-table-cell/data-table-cell.component';
import * as i22 from '../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-table/data-table-table.component.ngfactory';
import * as i23 from '@covalent/core/data-table/data-table-table/data-table-table.component';
import * as i24 from '../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-column/data-table-column.component.ngfactory';
import * as i25 from '@covalent/core/data-table/data-table-column/data-table-column.component';
import * as i26 from '../../../../../app/shared/pipes/translate.pipe';
import * as i27 from '@covalent/core/loading/directives/loading.directive';
import * as i28 from '@covalent/core/loading/services/loading.service';
import * as i29 from '../../../../../app/agatextscreens/sales/debit-note/debit-note.component';
import * as i30 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i31 from '../../../../../app/agatextscreens/accounting/customer/customer.service';
import * as i32 from '@covalent/http/interceptors/http-interceptor.service';
import * as i33 from '@angular/http';
import * as i34 from '../../../../../services/utils.service';
import * as i35 from '../../../../../app/app.constants';
import * as i36 from '../../../../../app/shared/services/authentication.service';
import * as i37 from '../../../../../app/shared/services/invoice.service';
import * as i38 from '../../../../../app/shared/services/report.service';
import * as i39 from '../../../../../app/agatextscreens/sales/sales.service';
import * as i40 from '@covalent/core/data-table/services/data-table.service';
import * as i41 from '@covalent/core/dialogs/services/dialog.service';
import * as i42 from '../../../../../app/shared/services/settings.service';
import * as i43 from '../../../../../app/agatextscreens/accounting/branches/branch.service';
import * as i44 from '../../../../../app/agatextscreens/inventory/inventory.service';
import * as i45 from '../../../../../app/agatextscreens/purchasing/pos/po.service';
const styles_DebitNoteComponent:any[] = [i0.styles];
export const RenderType_DebitNoteComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DebitNoteComponent,data:{}});
function View_DebitNoteComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'padded-container unsaved-changes'],['fxLayout','row'],['fxLayoutGap','30px']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
      (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
      {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
      i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['warning'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n  ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'padded-container unsaved-changes';
    _ck(_v,3,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = i1.ɵunv(_v,11,0,_ck(_v,12,0,i1.ɵnov((<any>_v.parent),0),
        'you_have_unsaved_changes',_co._authService.getLanguage()));
    _ck(_v,11,0,currVal_4);
  });
}
function View_DebitNoteComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'td-steps',[['mode',
      'horizontal']],(null as any),(null as any),(null as any),i8.View_TdStepsComponent_0,
      i8.RenderType_TdStepsComponent)),i1.ɵdid(1228800,(null as any),1,i9.TdStepsComponent,
      ([] as any[]),{mode:[0,'mode']},(null as any)),i1.ɵqud(603979776,1,{stepsContent:1}),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),5,'td-step',[['disabled','true'],['label','DRAFT'],['sublabel',
              'To be completed']],(null as any),(null as any),(null as any),i10.View_TdStepComponent_0,
          i10.RenderType_TdStepComponent)),i1.ɵdid(114688,[[1,4]],3,i11.TdStepComponent,
          [i1.ViewContainerRef],{label:[0,'label'],sublabel:[1,'sublabel'],active:[2,
              'active'],disabled:[3,'disabled'],state:[4,'state']},(null as any)),
      i1.ɵqud(335544320,2,{stepLabel:0}),i1.ɵqud(335544320,3,{stepActions:0}),i1.ɵqud(335544320,
          4,{stepSummary:0}),(_l()(),i1.ɵted(0,['NEXT: Move to SHIPPED status'])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),5,'td-step',[['disabled','true'],['label','SHIPPED'],['sublabel',
              'Order Completed']],(null as any),(null as any),(null as any),i10.View_TdStepComponent_0,
          i10.RenderType_TdStepComponent)),i1.ɵdid(114688,[[1,4]],3,i11.TdStepComponent,
          [i1.ViewContainerRef],{label:[0,'label'],sublabel:[1,'sublabel'],active:[2,
              'active'],disabled:[3,'disabled'],state:[4,'state']},(null as any)),
      i1.ɵqud(335544320,5,{stepLabel:0}),i1.ɵqud(335544320,6,{stepActions:0}),i1.ɵqud(335544320,
          7,{stepSummary:0}),(_l()(),i1.ɵted(0,['Completed'])),(_l()(),i1.ɵted((null as any),
          ['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'horizontal';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'DRAFT';
    const currVal_2:any = 'To be completed';
    const currVal_3:any = true;
    const currVal_4:any = 'true';
    const currVal_5:any = (_co.isDraft()? 'complete': 'none');
    _ck(_v,5,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = 'SHIPPED';
    const currVal_7:any = 'Order Completed';
    const currVal_8:any = true;
    const currVal_9:any = 'true';
    const currVal_10:any = (_co.isShipped()? 'complete': 'none');
    _ck(_v,12,0,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
  },(null as any));
}
function View_DebitNoteComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),15,'td-steps',[['mode',
      'horizontal']],(null as any),(null as any),(null as any),i8.View_TdStepsComponent_0,
      i8.RenderType_TdStepsComponent)),i1.ɵdid(1228800,(null as any),1,i9.TdStepsComponent,
      ([] as any[]),{mode:[0,'mode']},(null as any)),i1.ɵqud(603979776,8,{stepsContent:1}),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),4,'td-step',[['disabled','true'],['label','DRAFT'],['state',
              'complete'],['sublabel','To be completed']],(null as any),(null as any),
          (null as any),i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),
      i1.ɵdid(114688,[[8,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,
          'label'],sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
          state:[4,'state']},(null as any)),i1.ɵqud(335544320,9,{stepLabel:0}),i1.ɵqud(335544320,
          10,{stepActions:0}),i1.ɵqud(335544320,11,{stepSummary:0}),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),4,
          'td-step',[['disabled','true'],['label','DECLINED'],['state','complete'],
              ['sublabel','Order Declined']],(null as any),(null as any),(null as any),
          i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),i1.ɵdid(114688,
          [[8,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,'label'],sublabel:[1,
              'sublabel'],active:[2,'active'],disabled:[3,'disabled'],state:[4,'state']},
          (null as any)),i1.ɵqud(335544320,12,{stepLabel:0}),i1.ɵqud(335544320,13,
          {stepActions:0}),i1.ɵqud(335544320,14,{stepSummary:0}),(_l()(),i1.ɵted((null as any),
          ['\n      ']))],(_ck,_v) => {
    const currVal_0:any = 'horizontal';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'DRAFT';
    const currVal_2:any = 'To be completed';
    const currVal_3:any = true;
    const currVal_4:any = 'true';
    const currVal_5:any = 'complete';
    _ck(_v,5,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = 'DECLINED';
    const currVal_7:any = 'Order Declined';
    const currVal_8:any = true;
    const currVal_9:any = 'true';
    const currVal_10:any = 'complete';
    _ck(_v,11,0,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
  },(null as any));
}
function View_DebitNoteComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[15,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n              ',
          ''])),i1.ɵppd(2)],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = i1.ɵunv(_v,3,0,_ck(_v,4,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),_v.context.$implicit,_co._authService.getLanguage()));
    _ck(_v,3,0,currVal_10);
  });
}
function View_DebitNoteComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>_co.setSelected(_v.context.$implicit)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[28,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n                ',
          '\n              ']))],(_ck,_v) => {
    const currVal_9:any = ((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.prefix) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = ((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.prefix) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
    _ck(_v,3,0,currVal_10);
  });
}
function View_DebitNoteComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[41,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_10);
  });
}
function View_DebitNoteComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[48,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','/','\n            ']))],
      (_ck,_v) => {
        const currVal_9:any = _v.context.$implicit.id;
        _ck(_v,2,0,currVal_9);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
        const currVal_1:any = i1.ɵnov(_v,2).selected;
        const currVal_2:any = i1.ɵnov(_v,2).multiple;
        const currVal_3:any = i1.ɵnov(_v,2).active;
        const currVal_4:any = i1.ɵnov(_v,2).id;
        const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
        const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
        const currVal_7:any = i1.ɵnov(_v,2).disabled;
        const currVal_8:any = true;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8);
        const currVal_10:any = _v.context.$implicit.code;
        const currVal_11:any = _v.context.$implicit.name;
        _ck(_v,3,0,currVal_10,currVal_11);
      });
}
function View_DebitNoteComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),244,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'div',
          [['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],
              ['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),13,'md-select',[['fxFlex','22%'],
          ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
          [1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',
              0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',
              (null as any)],[2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,15)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentDebitNote.type = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,15,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,2,(null as any),View_DebitNoteComponent_6)),i1.ɵdid(802816,
          (null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpad(2),(_l()(),i1.ɵted(0,['\n          '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),93,'div',
          [['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],
              ['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,32)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,16,{_mdInputChild:0}),i1.ɵqud(335544320,17,{_placeholderChild:0}),
      i1.ɵqud(603979776,18,{_errorChildren:1}),i1.ɵqud(603979776,19,{_hintChildren:1}),
      i1.ɵqud(603979776,20,{_prefixChildren:1}),i1.ɵqud(603979776,21,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput',''],['readonly','']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,42)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,42).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,42)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,42)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,47)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,47)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,47)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.order_number = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[16,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),27,'md-input-container',[['fxFlex',
              '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,52)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,22,{_mdInputChild:0}),i1.ɵqud(335544320,23,{_placeholderChild:0}),
      i1.ɵqud(603979776,24,{_errorChildren:1}),i1.ɵqud(603979776,25,{_hintChildren:1}),
      i1.ɵqud(603979776,26,{_prefixChildren:1}),i1.ɵqud(603979776,27,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(16777216,
          (null as any),1,7,'input',[['aria-autocomplete','list'],['aria-multiline',
              'false'],['autocomplete','off'],['flex',''],['mdInput',''],['placeholder',
              'Prefix - Customer'],['role','combobox']],[[1,'aria-activedescendant',
              0],[1,'aria-expanded',0],[1,'aria-owns',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus'],[(null as any),'keydown']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,62)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,62).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,62)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,62)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,63).openPanel()) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,63)._handleInput($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,63)._onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('keydown' === en)) {
              const pd_7:any = ((<any>i1.ɵnov(_v,63)._handleKeydown($event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
              const pd_8:any = ((<any>i1.ɵnov(_v,68)._onBlur()) !== false);
              ad = (pd_8 && ad);
            }
            if (('focus' === en)) {
              const pd_9:any = ((<any>i1.ɵnov(_v,68)._onFocus()) !== false);
              ad = (pd_9 && ad);
            }
            if (('input' === en)) {
              const pd_10:any = ((<any>i1.ɵnov(_v,68)._onInput()) !== false);
              ad = (pd_10 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_11:any = ((<any>(_co.cust = $event)) !== false);
              ad = (pd_11 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_12:any = ((<any>_co.filter(_co.cust)) !== false);
              ad = (pd_12 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i7.MdAutocompleteTrigger,[i1.ElementRef,
          i7.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i7.ScrollDispatcher,
          [2,i7.Dir],i1.NgZone,[2,i7.MdInputContainer],[2,i16.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i12.DefaultValueAccessor,i7.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,
              i12.NG_VALUE_ACCESSOR]],{isDisabled:[0,'isDisabled'],model:[1,'model']},
          {update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i12.NgControl,(null as any),
          [i12.NgModel]),i1.ɵdid(16384,(null as any),0,i12.NgControlStatus,[i12.NgControl],
          (null as any),(null as any)),i1.ɵdid(16384,[[22,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],{disabled:[0,'disabled'],
              placeholder:[1,'placeholder']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',
          (null as any)]],(null as any),(null as any),i6.View_MdAutocomplete_0,i6.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['autoCustomer',
          4]],1,i7.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,28,{options:1}),(_l()(),i1.ɵted(0,['\n              '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_DebitNoteComponent_7)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,81)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,29,{_mdInputChild:0}),i1.ɵqud(335544320,30,{_placeholderChild:0}),
      i1.ɵqud(603979776,31,{_errorChildren:1}),i1.ɵqud(603979776,32,{_hintChildren:1}),
      i1.ɵqud(603979776,33,{_prefixChildren:1}),i1.ɵqud(603979776,34,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput',''],['type','date']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,91)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,91).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,91)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,91)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,96)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,96)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,96)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.order_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[29,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,101)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,35,{_mdInputChild:0}),i1.ɵqud(335544320,36,{_placeholderChild:0}),
      i1.ɵqud(603979776,37,{_errorChildren:1}),i1.ɵqud(603979776,38,{_hintChildren:1}),
      i1.ɵqud(603979776,39,{_prefixChildren:1}),i1.ɵqud(603979776,40,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput',''],['type','date']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,111)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,111).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,111)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,111)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,116)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,116)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,116)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.delivery_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[35,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),55,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',
          [['fxFlex','22%']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),12,'md-select',[['fxFlex','22%'],
          ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
          [1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',
              0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',
              (null as any)],[2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,134)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,134)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentDebitNote.status = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,41,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_DebitNoteComponent_8)),i1.ɵdid(802816,
          (null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,['\n          '])),
      (_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],
              [2,'mat-input-container',(null as any)],[2,'mat-input-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,144)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,42,{_mdInputChild:0}),i1.ɵqud(335544320,43,{_placeholderChild:0}),
      i1.ɵqud(603979776,44,{_errorChildren:1}),i1.ɵqud(603979776,45,{_hintChildren:1}),
      i1.ɵqud(603979776,46,{_prefixChildren:1}),i1.ɵqud(603979776,47,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput',''],['readonly','']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'input'],
              [(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
                  'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,154)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,154).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,154)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,154)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,159)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,159)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,159)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},(null as any)),i1.ɵprd(2048,(null as any),i12.NgControl,
          (null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,i12.NgControlStatus,
          [i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[42,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'md-select',
          [['fxFlex','22%'],['name','branch'],['role','listbox']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[1,'tabindex',0],[1,
                  'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',0],[1,
                  'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',
                  (null as any)],[2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,168)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,168)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.currentDebitNote.branch_id = $event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              _co.updateTax($event);
              _co.filterSalesmen();
              const pd_3:any = ((<any>_co.loadCustomers()) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,
              (null as any)]],{name:[0,'name'],isDisabled:[1,'isDisabled'],model:[2,
              'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i12.NgControl,
          (null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,i12.NgControlStatus,
          [i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(1294336,(null as any),1,i7.MdSelect,
          [i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,[2,i7.Dir],
              [2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder'],
              disabled:[1,'disabled']},(null as any)),i1.ɵqud(603979776,48,{options:1}),
      i1.ɵppd(2),i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),(_l()(),i1.ɵted(0,['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_DebitNoteComponent_9)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          65,'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,184)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,49,{_mdInputChild:0}),i1.ɵqud(335544320,50,{_placeholderChild:0}),
      i1.ɵqud(603979776,51,{_errorChildren:1}),i1.ɵqud(603979776,52,{_hintChildren:1}),
      i1.ɵqud(603979776,53,{_prefixChildren:1}),i1.ɵqud(603979776,54,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,8,'textarea',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,194)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,194).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,194)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,194)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,199)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,199)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,199)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.notes = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[49,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,205)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,55,{_mdInputChild:0}),i1.ɵqud(335544320,56,{_placeholderChild:0}),
      i1.ɵqud(603979776,57,{_errorChildren:1}),i1.ɵqud(603979776,58,{_hintChildren:1}),
      i1.ɵqud(603979776,59,{_prefixChildren:1}),i1.ɵqud(603979776,60,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,215)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,215).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,215)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,215)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,220)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,220)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,220)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.customer_po = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[55,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
              '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,225)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,61,{_mdInputChild:0}),i1.ɵqud(335544320,62,{_placeholderChild:0}),
      i1.ɵqud(603979776,63,{_errorChildren:1}),i1.ɵqud(603979776,64,{_hintChildren:1}),
      i1.ɵqud(603979776,65,{_prefixChildren:1}),i1.ɵqud(603979776,66,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,235)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,235).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,235)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,235)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,240)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,240)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,240)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentDebitNote.invoice_number = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[61,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵted((null as any),['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'row';
    const currVal_3:any = 'column';
    _ck(_v,6,0,currVal_2,currVal_3);
    const currVal_4:any = '30px';
    const currVal_5:any = '14px';
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = 'padded-container';
    _ck(_v,8,0,currVal_6);
    const currVal_23:any = _co.currentDebitNote.type;
    _ck(_v,11,0,currVal_23);
    const currVal_24:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,17,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'type',_co._authService.getLanguage())),
        '');
    _ck(_v,15,0,currVal_24);
    const currVal_25:any = '22%';
    _ck(_v,18,0,currVal_25);
    const currVal_26:any = _ck(_v,22,0,'Credit','Debit');
    _ck(_v,21,0,currVal_26);
    const currVal_27:any = 'row';
    const currVal_28:any = 'column';
    _ck(_v,27,0,currVal_27,currVal_28);
    const currVal_29:any = '30px';
    const currVal_30:any = '14px';
    _ck(_v,28,0,currVal_29,currVal_30);
    const currVal_31:any = 'padded-container';
    _ck(_v,29,0,currVal_31);
    const currVal_43:any = '22%';
    _ck(_v,39,0,currVal_43);
    const currVal_57:any = _co.currentDebitNote.order_number;
    _ck(_v,44,0,currVal_57);
    const currVal_58:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,47,0,_ck(_v,48,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'order_number',_co._authService.getLanguage())),
        '');
    _ck(_v,47,0,currVal_58);
    const currVal_70:any = '22%';
    _ck(_v,59,0,currVal_70);
    const currVal_87:any = i1.ɵnov(_v,72);
    _ck(_v,63,0,currVal_87);
    const currVal_88:any = _co.isEditMode;
    const currVal_89:any = _co.cust;
    _ck(_v,65,0,currVal_88,currVal_89);
    const currVal_90:any = _co.isEditMode;
    const currVal_91:any = 'Prefix - Customer';
    _ck(_v,68,0,currVal_90,currVal_91);
    const currVal_93:any = _co.matchingCustomers;
    _ck(_v,76,0,currVal_93);
    const currVal_105:any = '22%';
    _ck(_v,88,0,currVal_105);
    const currVal_119:any = _co.currentDebitNote.order_date;
    _ck(_v,93,0,currVal_119);
    const currVal_120:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,96,0,_ck(_v,97,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'order_date',_co._authService.getLanguage())),
        '');
    const currVal_121:any = 'date';
    _ck(_v,96,0,currVal_120,currVal_121);
    const currVal_133:any = '22%';
    _ck(_v,108,0,currVal_133);
    const currVal_147:any = _co.currentDebitNote.delivery_date;
    _ck(_v,113,0,currVal_147);
    const currVal_148:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,116,0,_ck(_v,117,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'delivery_date',_co._authService.getLanguage())),
        '');
    const currVal_149:any = 'date';
    _ck(_v,116,0,currVal_148,currVal_149);
    const currVal_150:any = 'row';
    const currVal_151:any = 'column';
    _ck(_v,122,0,currVal_150,currVal_151);
    const currVal_152:any = '30px';
    const currVal_153:any = '14px';
    _ck(_v,123,0,currVal_152,currVal_153);
    const currVal_154:any = 'padded-container';
    _ck(_v,124,0,currVal_154);
    const currVal_155:any = '22%';
    _ck(_v,127,0,currVal_155);
    const currVal_172:any = _co.currentDebitNote.status;
    _ck(_v,130,0,currVal_172);
    const currVal_173:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,134,0,_ck(_v,136,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'status',_co._authService.getLanguage())),
        '');
    _ck(_v,134,0,currVal_173);
    const currVal_174:any = '22%';
    _ck(_v,137,0,currVal_174);
    const currVal_175:any = _co.availableStatuses;
    _ck(_v,140,0,currVal_175);
    const currVal_187:any = '22%';
    _ck(_v,151,0,currVal_187);
    const currVal_201:any = _co.currentDebitNote.salesman;
    _ck(_v,156,0,currVal_201);
    const currVal_202:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,159,0,_ck(_v,160,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'salesman',_co._authService.getLanguage())),
        '');
    _ck(_v,159,0,currVal_202);
    const currVal_219:any = 'branch';
    const currVal_220:any = _co.isEditMode;
    const currVal_221:any = _co.currentDebitNote.branch_id;
    _ck(_v,164,0,currVal_219,currVal_220,currVal_221);
    const currVal_222:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,168,0,_ck(_v,170,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'branch',_co._authService.getLanguage())),
        '');
    const currVal_223:any = _co.isEditMode;
    _ck(_v,168,0,currVal_222,currVal_223);
    const currVal_224:any = '22%';
    _ck(_v,171,0,currVal_224);
    const currVal_225:any = _co.filteredBranches;
    _ck(_v,174,0,currVal_225);
    const currVal_226:any = 'row';
    const currVal_227:any = 'column';
    _ck(_v,179,0,currVal_226,currVal_227);
    const currVal_228:any = '30px';
    const currVal_229:any = '14px';
    _ck(_v,180,0,currVal_228,currVal_229);
    const currVal_230:any = 'padded-container';
    _ck(_v,181,0,currVal_230);
    const currVal_242:any = '47%';
    _ck(_v,191,0,currVal_242);
    const currVal_256:any = _co.currentDebitNote.notes;
    _ck(_v,196,0,currVal_256);
    const currVal_257:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,199,0,_ck(_v,200,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'notes',_co._authService.getLanguage())),
        '');
    _ck(_v,199,0,currVal_257);
    const currVal_270:any = '22%';
    _ck(_v,212,0,currVal_270);
    const currVal_284:any = _co.currentDebitNote.customer_po;
    _ck(_v,217,0,currVal_284);
    const currVal_285:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,220,0,_ck(_v,221,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'customer_po_reference',_co._authService.getLanguage())),
        '');
    _ck(_v,220,0,currVal_285);
    const currVal_297:any = '22%';
    _ck(_v,232,0,currVal_297);
    const currVal_311:any = _co.currentDebitNote.invoice_number;
    _ck(_v,237,0,currVal_311);
    const currVal_312:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,240,0,_ck(_v,241,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'invoice_number',_co._authService.getLanguage())),
        '');
    _ck(_v,240,0,currVal_312);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_7:any = i1.ɵnov(_v,13).ngClassUntouched;
    const currVal_8:any = i1.ɵnov(_v,13).ngClassTouched;
    const currVal_9:any = i1.ɵnov(_v,13).ngClassPristine;
    const currVal_10:any = i1.ɵnov(_v,13).ngClassDirty;
    const currVal_11:any = i1.ɵnov(_v,13).ngClassValid;
    const currVal_12:any = i1.ɵnov(_v,13).ngClassInvalid;
    const currVal_13:any = i1.ɵnov(_v,13).ngClassPending;
    const currVal_14:any = i1.ɵnov(_v,15).tabIndex;
    const currVal_15:any = i1.ɵnov(_v,15)._ariaLabel;
    const currVal_16:any = i1.ɵnov(_v,15).ariaLabelledby;
    const currVal_17:any = i1.ɵnov(_v,15).required.toString();
    const currVal_18:any = i1.ɵnov(_v,15).disabled.toString();
    const currVal_19:any = (((i1.ɵnov(_v,15)._control == null)? (null as any): i1.ɵnov(_v,
        15)._control.invalid) || 'false');
    const currVal_20:any = i1.ɵnov(_v,15)._optionIds;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = true;
    _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,
        currVal_21,currVal_22]);
    const currVal_32:any = (null as any);
    const currVal_33:any = true;
    const currVal_34:any = i1.ɵnov(_v,32)._isErrorState();
    const currVal_35:any = i1.ɵnov(_v,32)._mdInputChild.focused;
    const currVal_36:any = i1.ɵnov(_v,32)._shouldForward('untouched');
    const currVal_37:any = i1.ɵnov(_v,32)._shouldForward('touched');
    const currVal_38:any = i1.ɵnov(_v,32)._shouldForward('pristine');
    const currVal_39:any = i1.ɵnov(_v,32)._shouldForward('dirty');
    const currVal_40:any = i1.ɵnov(_v,32)._shouldForward('valid');
    const currVal_41:any = i1.ɵnov(_v,32)._shouldForward('invalid');
    const currVal_42:any = i1.ɵnov(_v,32)._shouldForward('pending');
    _ck(_v,31,1,[currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,
        currVal_38,currVal_39,currVal_40,currVal_41,currVal_42]);
    const currVal_44:any = i1.ɵnov(_v,46).ngClassUntouched;
    const currVal_45:any = i1.ɵnov(_v,46).ngClassTouched;
    const currVal_46:any = i1.ɵnov(_v,46).ngClassPristine;
    const currVal_47:any = i1.ɵnov(_v,46).ngClassDirty;
    const currVal_48:any = i1.ɵnov(_v,46).ngClassValid;
    const currVal_49:any = i1.ɵnov(_v,46).ngClassInvalid;
    const currVal_50:any = i1.ɵnov(_v,46).ngClassPending;
    const currVal_51:any = true;
    const currVal_52:any = i1.ɵnov(_v,47).id;
    const currVal_53:any = i1.ɵnov(_v,47).placeholder;
    const currVal_54:any = i1.ɵnov(_v,47).disabled;
    const currVal_55:any = i1.ɵnov(_v,47).required;
    const currVal_56:any = (i1.ɵnov(_v,47).ariaDescribedby || (null as any));
    _ck(_v,41,1,[currVal_44,currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,
        currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56]);
    const currVal_59:any = (null as any);
    const currVal_60:any = true;
    const currVal_61:any = i1.ɵnov(_v,52)._isErrorState();
    const currVal_62:any = i1.ɵnov(_v,52)._mdInputChild.focused;
    const currVal_63:any = i1.ɵnov(_v,52)._shouldForward('untouched');
    const currVal_64:any = i1.ɵnov(_v,52)._shouldForward('touched');
    const currVal_65:any = i1.ɵnov(_v,52)._shouldForward('pristine');
    const currVal_66:any = i1.ɵnov(_v,52)._shouldForward('dirty');
    const currVal_67:any = i1.ɵnov(_v,52)._shouldForward('valid');
    const currVal_68:any = i1.ɵnov(_v,52)._shouldForward('invalid');
    const currVal_69:any = i1.ɵnov(_v,52)._shouldForward('pending');
    _ck(_v,51,1,[currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,
        currVal_65,currVal_66,currVal_67,currVal_68,currVal_69]);
    const currVal_71:any = ((i1.ɵnov(_v,63).activeOption == null)? (null as any): i1.ɵnov(_v,
        63).activeOption.id);
    const currVal_72:any = i1.ɵnov(_v,63).panelOpen.toString();
    const currVal_73:any = ((i1.ɵnov(_v,63).autocomplete == null)? (null as any): i1.ɵnov(_v,
        63).autocomplete.id);
    const currVal_74:any = i1.ɵnov(_v,67).ngClassUntouched;
    const currVal_75:any = i1.ɵnov(_v,67).ngClassTouched;
    const currVal_76:any = i1.ɵnov(_v,67).ngClassPristine;
    const currVal_77:any = i1.ɵnov(_v,67).ngClassDirty;
    const currVal_78:any = i1.ɵnov(_v,67).ngClassValid;
    const currVal_79:any = i1.ɵnov(_v,67).ngClassInvalid;
    const currVal_80:any = i1.ɵnov(_v,67).ngClassPending;
    const currVal_81:any = true;
    const currVal_82:any = i1.ɵnov(_v,68).id;
    const currVal_83:any = i1.ɵnov(_v,68).placeholder;
    const currVal_84:any = i1.ɵnov(_v,68).disabled;
    const currVal_85:any = i1.ɵnov(_v,68).required;
    const currVal_86:any = (i1.ɵnov(_v,68).ariaDescribedby || (null as any));
    _ck(_v,61,1,[currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76,
        currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,currVal_83,
        currVal_84,currVal_85,currVal_86]);
    const currVal_92:any = true;
    _ck(_v,70,0,currVal_92);
    const currVal_94:any = (null as any);
    const currVal_95:any = true;
    const currVal_96:any = i1.ɵnov(_v,81)._isErrorState();
    const currVal_97:any = i1.ɵnov(_v,81)._mdInputChild.focused;
    const currVal_98:any = i1.ɵnov(_v,81)._shouldForward('untouched');
    const currVal_99:any = i1.ɵnov(_v,81)._shouldForward('touched');
    const currVal_100:any = i1.ɵnov(_v,81)._shouldForward('pristine');
    const currVal_101:any = i1.ɵnov(_v,81)._shouldForward('dirty');
    const currVal_102:any = i1.ɵnov(_v,81)._shouldForward('valid');
    const currVal_103:any = i1.ɵnov(_v,81)._shouldForward('invalid');
    const currVal_104:any = i1.ɵnov(_v,81)._shouldForward('pending');
    _ck(_v,80,1,[currVal_94,currVal_95,currVal_96,currVal_97,currVal_98,currVal_99,
        currVal_100,currVal_101,currVal_102,currVal_103,currVal_104]);
    const currVal_106:any = i1.ɵnov(_v,95).ngClassUntouched;
    const currVal_107:any = i1.ɵnov(_v,95).ngClassTouched;
    const currVal_108:any = i1.ɵnov(_v,95).ngClassPristine;
    const currVal_109:any = i1.ɵnov(_v,95).ngClassDirty;
    const currVal_110:any = i1.ɵnov(_v,95).ngClassValid;
    const currVal_111:any = i1.ɵnov(_v,95).ngClassInvalid;
    const currVal_112:any = i1.ɵnov(_v,95).ngClassPending;
    const currVal_113:any = true;
    const currVal_114:any = i1.ɵnov(_v,96).id;
    const currVal_115:any = i1.ɵnov(_v,96).placeholder;
    const currVal_116:any = i1.ɵnov(_v,96).disabled;
    const currVal_117:any = i1.ɵnov(_v,96).required;
    const currVal_118:any = (i1.ɵnov(_v,96).ariaDescribedby || (null as any));
    _ck(_v,90,1,[currVal_106,currVal_107,currVal_108,currVal_109,currVal_110,currVal_111,
        currVal_112,currVal_113,currVal_114,currVal_115,currVal_116,currVal_117,currVal_118]);
    const currVal_122:any = (null as any);
    const currVal_123:any = true;
    const currVal_124:any = i1.ɵnov(_v,101)._isErrorState();
    const currVal_125:any = i1.ɵnov(_v,101)._mdInputChild.focused;
    const currVal_126:any = i1.ɵnov(_v,101)._shouldForward('untouched');
    const currVal_127:any = i1.ɵnov(_v,101)._shouldForward('touched');
    const currVal_128:any = i1.ɵnov(_v,101)._shouldForward('pristine');
    const currVal_129:any = i1.ɵnov(_v,101)._shouldForward('dirty');
    const currVal_130:any = i1.ɵnov(_v,101)._shouldForward('valid');
    const currVal_131:any = i1.ɵnov(_v,101)._shouldForward('invalid');
    const currVal_132:any = i1.ɵnov(_v,101)._shouldForward('pending');
    _ck(_v,100,1,[currVal_122,currVal_123,currVal_124,currVal_125,currVal_126,currVal_127,
        currVal_128,currVal_129,currVal_130,currVal_131,currVal_132]);
    const currVal_134:any = i1.ɵnov(_v,115).ngClassUntouched;
    const currVal_135:any = i1.ɵnov(_v,115).ngClassTouched;
    const currVal_136:any = i1.ɵnov(_v,115).ngClassPristine;
    const currVal_137:any = i1.ɵnov(_v,115).ngClassDirty;
    const currVal_138:any = i1.ɵnov(_v,115).ngClassValid;
    const currVal_139:any = i1.ɵnov(_v,115).ngClassInvalid;
    const currVal_140:any = i1.ɵnov(_v,115).ngClassPending;
    const currVal_141:any = true;
    const currVal_142:any = i1.ɵnov(_v,116).id;
    const currVal_143:any = i1.ɵnov(_v,116).placeholder;
    const currVal_144:any = i1.ɵnov(_v,116).disabled;
    const currVal_145:any = i1.ɵnov(_v,116).required;
    const currVal_146:any = (i1.ɵnov(_v,116).ariaDescribedby || (null as any));
    _ck(_v,110,1,[currVal_134,currVal_135,currVal_136,currVal_137,currVal_138,currVal_139,
        currVal_140,currVal_141,currVal_142,currVal_143,currVal_144,currVal_145,currVal_146]);
    const currVal_156:any = i1.ɵnov(_v,132).ngClassUntouched;
    const currVal_157:any = i1.ɵnov(_v,132).ngClassTouched;
    const currVal_158:any = i1.ɵnov(_v,132).ngClassPristine;
    const currVal_159:any = i1.ɵnov(_v,132).ngClassDirty;
    const currVal_160:any = i1.ɵnov(_v,132).ngClassValid;
    const currVal_161:any = i1.ɵnov(_v,132).ngClassInvalid;
    const currVal_162:any = i1.ɵnov(_v,132).ngClassPending;
    const currVal_163:any = i1.ɵnov(_v,134).tabIndex;
    const currVal_164:any = i1.ɵnov(_v,134)._ariaLabel;
    const currVal_165:any = i1.ɵnov(_v,134).ariaLabelledby;
    const currVal_166:any = i1.ɵnov(_v,134).required.toString();
    const currVal_167:any = i1.ɵnov(_v,134).disabled.toString();
    const currVal_168:any = (((i1.ɵnov(_v,134)._control == null)? (null as any): i1.ɵnov(_v,
        134)._control.invalid) || 'false');
    const currVal_169:any = i1.ɵnov(_v,134)._optionIds;
    const currVal_170:any = i1.ɵnov(_v,134).disabled;
    const currVal_171:any = true;
    _ck(_v,129,1,[currVal_156,currVal_157,currVal_158,currVal_159,currVal_160,currVal_161,
        currVal_162,currVal_163,currVal_164,currVal_165,currVal_166,currVal_167,currVal_168,
        currVal_169,currVal_170,currVal_171]);
    const currVal_176:any = (null as any);
    const currVal_177:any = true;
    const currVal_178:any = i1.ɵnov(_v,144)._isErrorState();
    const currVal_179:any = i1.ɵnov(_v,144)._mdInputChild.focused;
    const currVal_180:any = i1.ɵnov(_v,144)._shouldForward('untouched');
    const currVal_181:any = i1.ɵnov(_v,144)._shouldForward('touched');
    const currVal_182:any = i1.ɵnov(_v,144)._shouldForward('pristine');
    const currVal_183:any = i1.ɵnov(_v,144)._shouldForward('dirty');
    const currVal_184:any = i1.ɵnov(_v,144)._shouldForward('valid');
    const currVal_185:any = i1.ɵnov(_v,144)._shouldForward('invalid');
    const currVal_186:any = i1.ɵnov(_v,144)._shouldForward('pending');
    _ck(_v,143,1,[currVal_176,currVal_177,currVal_178,currVal_179,currVal_180,currVal_181,
        currVal_182,currVal_183,currVal_184,currVal_185,currVal_186]);
    const currVal_188:any = i1.ɵnov(_v,158).ngClassUntouched;
    const currVal_189:any = i1.ɵnov(_v,158).ngClassTouched;
    const currVal_190:any = i1.ɵnov(_v,158).ngClassPristine;
    const currVal_191:any = i1.ɵnov(_v,158).ngClassDirty;
    const currVal_192:any = i1.ɵnov(_v,158).ngClassValid;
    const currVal_193:any = i1.ɵnov(_v,158).ngClassInvalid;
    const currVal_194:any = i1.ɵnov(_v,158).ngClassPending;
    const currVal_195:any = true;
    const currVal_196:any = i1.ɵnov(_v,159).id;
    const currVal_197:any = i1.ɵnov(_v,159).placeholder;
    const currVal_198:any = i1.ɵnov(_v,159).disabled;
    const currVal_199:any = i1.ɵnov(_v,159).required;
    const currVal_200:any = (i1.ɵnov(_v,159).ariaDescribedby || (null as any));
    _ck(_v,153,1,[currVal_188,currVal_189,currVal_190,currVal_191,currVal_192,currVal_193,
        currVal_194,currVal_195,currVal_196,currVal_197,currVal_198,currVal_199,currVal_200]);
    const currVal_203:any = i1.ɵnov(_v,166).ngClassUntouched;
    const currVal_204:any = i1.ɵnov(_v,166).ngClassTouched;
    const currVal_205:any = i1.ɵnov(_v,166).ngClassPristine;
    const currVal_206:any = i1.ɵnov(_v,166).ngClassDirty;
    const currVal_207:any = i1.ɵnov(_v,166).ngClassValid;
    const currVal_208:any = i1.ɵnov(_v,166).ngClassInvalid;
    const currVal_209:any = i1.ɵnov(_v,166).ngClassPending;
    const currVal_210:any = i1.ɵnov(_v,168).tabIndex;
    const currVal_211:any = i1.ɵnov(_v,168)._ariaLabel;
    const currVal_212:any = i1.ɵnov(_v,168).ariaLabelledby;
    const currVal_213:any = i1.ɵnov(_v,168).required.toString();
    const currVal_214:any = i1.ɵnov(_v,168).disabled.toString();
    const currVal_215:any = (((i1.ɵnov(_v,168)._control == null)? (null as any): i1.ɵnov(_v,
        168)._control.invalid) || 'false');
    const currVal_216:any = i1.ɵnov(_v,168)._optionIds;
    const currVal_217:any = i1.ɵnov(_v,168).disabled;
    const currVal_218:any = true;
    _ck(_v,163,1,[currVal_203,currVal_204,currVal_205,currVal_206,currVal_207,currVal_208,
        currVal_209,currVal_210,currVal_211,currVal_212,currVal_213,currVal_214,currVal_215,
        currVal_216,currVal_217,currVal_218]);
    const currVal_231:any = (null as any);
    const currVal_232:any = true;
    const currVal_233:any = i1.ɵnov(_v,184)._isErrorState();
    const currVal_234:any = i1.ɵnov(_v,184)._mdInputChild.focused;
    const currVal_235:any = i1.ɵnov(_v,184)._shouldForward('untouched');
    const currVal_236:any = i1.ɵnov(_v,184)._shouldForward('touched');
    const currVal_237:any = i1.ɵnov(_v,184)._shouldForward('pristine');
    const currVal_238:any = i1.ɵnov(_v,184)._shouldForward('dirty');
    const currVal_239:any = i1.ɵnov(_v,184)._shouldForward('valid');
    const currVal_240:any = i1.ɵnov(_v,184)._shouldForward('invalid');
    const currVal_241:any = i1.ɵnov(_v,184)._shouldForward('pending');
    _ck(_v,183,1,[currVal_231,currVal_232,currVal_233,currVal_234,currVal_235,currVal_236,
        currVal_237,currVal_238,currVal_239,currVal_240,currVal_241]);
    const currVal_243:any = i1.ɵnov(_v,198).ngClassUntouched;
    const currVal_244:any = i1.ɵnov(_v,198).ngClassTouched;
    const currVal_245:any = i1.ɵnov(_v,198).ngClassPristine;
    const currVal_246:any = i1.ɵnov(_v,198).ngClassDirty;
    const currVal_247:any = i1.ɵnov(_v,198).ngClassValid;
    const currVal_248:any = i1.ɵnov(_v,198).ngClassInvalid;
    const currVal_249:any = i1.ɵnov(_v,198).ngClassPending;
    const currVal_250:any = true;
    const currVal_251:any = i1.ɵnov(_v,199).id;
    const currVal_252:any = i1.ɵnov(_v,199).placeholder;
    const currVal_253:any = i1.ɵnov(_v,199).disabled;
    const currVal_254:any = i1.ɵnov(_v,199).required;
    const currVal_255:any = (i1.ɵnov(_v,199).ariaDescribedby || (null as any));
    _ck(_v,193,1,[currVal_243,currVal_244,currVal_245,currVal_246,currVal_247,currVal_248,
        currVal_249,currVal_250,currVal_251,currVal_252,currVal_253,currVal_254,currVal_255]);
    const currVal_258:any = _co.currentDebitNote.notes;
    _ck(_v,201,0,currVal_258);
    const currVal_259:any = (null as any);
    const currVal_260:any = true;
    const currVal_261:any = i1.ɵnov(_v,205)._isErrorState();
    const currVal_262:any = i1.ɵnov(_v,205)._mdInputChild.focused;
    const currVal_263:any = i1.ɵnov(_v,205)._shouldForward('untouched');
    const currVal_264:any = i1.ɵnov(_v,205)._shouldForward('touched');
    const currVal_265:any = i1.ɵnov(_v,205)._shouldForward('pristine');
    const currVal_266:any = i1.ɵnov(_v,205)._shouldForward('dirty');
    const currVal_267:any = i1.ɵnov(_v,205)._shouldForward('valid');
    const currVal_268:any = i1.ɵnov(_v,205)._shouldForward('invalid');
    const currVal_269:any = i1.ɵnov(_v,205)._shouldForward('pending');
    _ck(_v,204,1,[currVal_259,currVal_260,currVal_261,currVal_262,currVal_263,currVal_264,
        currVal_265,currVal_266,currVal_267,currVal_268,currVal_269]);
    const currVal_271:any = i1.ɵnov(_v,219).ngClassUntouched;
    const currVal_272:any = i1.ɵnov(_v,219).ngClassTouched;
    const currVal_273:any = i1.ɵnov(_v,219).ngClassPristine;
    const currVal_274:any = i1.ɵnov(_v,219).ngClassDirty;
    const currVal_275:any = i1.ɵnov(_v,219).ngClassValid;
    const currVal_276:any = i1.ɵnov(_v,219).ngClassInvalid;
    const currVal_277:any = i1.ɵnov(_v,219).ngClassPending;
    const currVal_278:any = true;
    const currVal_279:any = i1.ɵnov(_v,220).id;
    const currVal_280:any = i1.ɵnov(_v,220).placeholder;
    const currVal_281:any = i1.ɵnov(_v,220).disabled;
    const currVal_282:any = i1.ɵnov(_v,220).required;
    const currVal_283:any = (i1.ɵnov(_v,220).ariaDescribedby || (null as any));
    _ck(_v,214,1,[currVal_271,currVal_272,currVal_273,currVal_274,currVal_275,currVal_276,
        currVal_277,currVal_278,currVal_279,currVal_280,currVal_281,currVal_282,currVal_283]);
    const currVal_286:any = (null as any);
    const currVal_287:any = true;
    const currVal_288:any = i1.ɵnov(_v,225)._isErrorState();
    const currVal_289:any = i1.ɵnov(_v,225)._mdInputChild.focused;
    const currVal_290:any = i1.ɵnov(_v,225)._shouldForward('untouched');
    const currVal_291:any = i1.ɵnov(_v,225)._shouldForward('touched');
    const currVal_292:any = i1.ɵnov(_v,225)._shouldForward('pristine');
    const currVal_293:any = i1.ɵnov(_v,225)._shouldForward('dirty');
    const currVal_294:any = i1.ɵnov(_v,225)._shouldForward('valid');
    const currVal_295:any = i1.ɵnov(_v,225)._shouldForward('invalid');
    const currVal_296:any = i1.ɵnov(_v,225)._shouldForward('pending');
    _ck(_v,224,1,[currVal_286,currVal_287,currVal_288,currVal_289,currVal_290,currVal_291,
        currVal_292,currVal_293,currVal_294,currVal_295,currVal_296]);
    const currVal_298:any = i1.ɵnov(_v,239).ngClassUntouched;
    const currVal_299:any = i1.ɵnov(_v,239).ngClassTouched;
    const currVal_300:any = i1.ɵnov(_v,239).ngClassPristine;
    const currVal_301:any = i1.ɵnov(_v,239).ngClassDirty;
    const currVal_302:any = i1.ɵnov(_v,239).ngClassValid;
    const currVal_303:any = i1.ɵnov(_v,239).ngClassInvalid;
    const currVal_304:any = i1.ɵnov(_v,239).ngClassPending;
    const currVal_305:any = true;
    const currVal_306:any = i1.ɵnov(_v,240).id;
    const currVal_307:any = i1.ɵnov(_v,240).placeholder;
    const currVal_308:any = i1.ɵnov(_v,240).disabled;
    const currVal_309:any = i1.ɵnov(_v,240).required;
    const currVal_310:any = (i1.ɵnov(_v,240).ariaDescribedby || (null as any));
    _ck(_v,234,1,[currVal_298,currVal_299,currVal_300,currVal_301,currVal_302,currVal_303,
        currVal_304,currVal_305,currVal_306,currVal_307,currVal_308,currVal_309,currVal_310]);
  });
}
function View_DebitNoteComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),42,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i6.View_MdCard_0,
      i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,
          (null as any),View_DebitNoteComponent_3)),i1.ɵdid(16384,(null as any),0,
          i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,
          (null as any),View_DebitNoteComponent_4)),i1.ɵdid(16384,(null as any),0,
          i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,28,'md-card-header',
          [['fxLayout','column']],[[2,'mat-card-header',(null as any)]],(null as any),
          (null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'span',
          [['class','md-title'],['fxFlex','100']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i13.FlexDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['',' /\n            '])),i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'a',([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i17.RouterLinkWithHref,
          [i17.Router,i17.ActivatedRoute,i15.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' / ','\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted(2,['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],[[2,'mat-card-subtitle',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          ',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_DebitNoteComponent_5)),i1.ɵdid(16384,
          (null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:boolean = !_co.isDeclined();
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = _co.isDeclined();
    _ck(_v,8,0,currVal_2);
    const currVal_4:any = 'column';
    _ck(_v,13,0,currVal_4);
    const currVal_6:any = '100';
    _ck(_v,20,0,currVal_6);
    const currVal_7:any = 'md-title';
    _ck(_v,21,0,currVal_7);
    const currVal_11:any = _ck(_v,26,0,'/debitnotes/list');
    _ck(_v,25,0,currVal_11);
    const currVal_15:any = 'bg-grey color-white text-only';
    _ck(_v,35,0,currVal_15);
    const currVal_17:any = _co.currentDebitNote;
    _ck(_v,41,0,currVal_17);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = true;
    _ck(_v,10,0,currVal_3);
    const currVal_5:any = true;
    _ck(_v,15,0,currVal_5);
    const currVal_8:any = i1.ɵunv(_v,22,0,_ck(_v,23,0,i1.ɵnov((<any>_v.parent),0),
        'debit_and_credit_notes',_co._authService.getLanguage()));
    _ck(_v,22,0,currVal_8);
    const currVal_9:any = i1.ɵnov(_v,25).target;
    const currVal_10:any = i1.ɵnov(_v,25).href;
    _ck(_v,24,0,currVal_9,currVal_10);
    const currVal_12:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov((<any>_v.parent),0),
        'list',_co._authService.getLanguage()));
    _ck(_v,27,0,currVal_12);
    const currVal_13:any = ((_co.isEditMode && _co.currentDebitNote)? _co.currentDebitNote.order_number: _co.title);
    _ck(_v,29,0,currVal_13);
    const currVal_14:any = true;
    _ck(_v,32,0,currVal_14);
    const currVal_16:any = i1.ɵunv(_v,36,0,_ck(_v,37,0,i1.ɵnov((<any>_v.parent),0),
        'order_details',_co._authService.getLanguage()));
    _ck(_v,36,0,currVal_16);
  });
}
function View_DebitNoteComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'tr',[['td-data-table-row',
      '']],(null as any),(null as any),(null as any),i18.View_TdDataTableRowComponent_0,
      i18.RenderType_TdDataTableRowComponent)),i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,
      [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
      ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell',
      '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
      i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,i21.TdDataTableCellComponent,
      [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
      ['',''])),(_l()(),i1.ɵted(0,['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
      0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],(null as any),
      (null as any),i20.View_TdDataTableCellComponent_0,i20.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted(0,
          ['\n              ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,4).bindNumeric;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _v.context.$implicit['description'];
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = i1.ɵnov(_v,8).bindNumeric;
    _ck(_v,7,0,currVal_2);
    const currVal_3:any = _v.context.$implicit['price'];
    _ck(_v,9,0,currVal_3);
  });
}
function View_DebitNoteComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),104,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),98,'div',
          [['class','mat-table-container tmp-driven-table']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),94,'table',[['class','duplicated-thead-fix'],
              ['td-data-table','']],(null as any),(null as any),(null as any),i22.View_TdDataTableTableComponent_0,
              i22.RenderType_TdDataTableTableComponent)),i1.ɵdid(49152,(null as any),
          0,i23.TdDataTableTableComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),1,12,'thead',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n              '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'tr',
          [['td-data-table-column-row','']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'th',[['td-data-table-column',
          '']],[[2,'mat-clickable',(null as any)],[2,'mat-sortable',(null as any)],
          [2,'mat-active',(null as any)],[2,'mat-numeric',(null as any)]],(null as any),
          (null as any),i24.View_TdDataTableColumnComponent_0,i24.RenderType_TdDataTableColumnComponent)),
      i1.ɵdid(49152,(null as any),0,i25.TdDataTableColumnComponent,[i1.ElementRef,
          i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,['Description'])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'th',[['td-data-table-column','']],[[2,'mat-clickable',(null as any)],
              [2,'mat-sortable',(null as any)],[2,'mat-active',(null as any)],[2,'mat-numeric',
                  (null as any)]],(null as any),(null as any),i24.View_TdDataTableColumnComponent_0,
          i24.RenderType_TdDataTableColumnComponent)),i1.ɵdid(49152,(null as any),
          0,i25.TdDataTableColumnComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['Price'])),(_l()(),i1.ɵted((null as any),
          ['\n              '])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,75,
          'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n              '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DebitNoteComponent_11)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n              '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,
          'tr',[['td-data-table-row','']],(null as any),(null as any),(null as any),
          i18.View_TdDataTableRowComponent_0,i18.RenderType_TdDataTableRowComponent)),
      i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,[' '])),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,[' '])),(_l()(),i1.ɵted(0,['\n              '])),
      (_l()(),i1.ɵted((null as any),['\n              '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),12,'tr',[['td-data-table-row','']],(null as any),(null as any),
          (null as any),i18.View_TdDataTableRowComponent_0,i18.RenderType_TdDataTableRowComponent)),
      i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n                  ','\n                '])),
      i1.ɵppd(2),(_l()(),i1.ɵted(0,['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],(null as any),
          (null as any),i20.View_TdDataTableCellComponent_0,i20.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(0,['\n              '])),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),12,'tr',[['td-data-table-row',
          '']],(null as any),(null as any),(null as any),i18.View_TdDataTableRowComponent_0,
          i18.RenderType_TdDataTableRowComponent)),i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,
          [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['style',
          'cursor:pointer'],['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>(!_co.isShipped() && _co.openModifyTax1())) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i20.View_TdDataTableCellComponent_0,i20.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                  ',' (',
          '%)\n                '])),i1.ɵppd(2),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(0,
          ['\n              '])),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),12,'tr',[['td-data-table-row',
          '']],(null as any),(null as any),(null as any),i18.View_TdDataTableRowComponent_0,
          i18.RenderType_TdDataTableRowComponent)),i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,
          [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['style',
          'cursor:pointer'],['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>(!_co.isShipped() && _co.openModifyTax2())) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i20.View_TdDataTableCellComponent_0,i20.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                  ',' (',
          '%)\n                '])),i1.ɵppd(2),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(0,
          ['\n              '])),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),15,'tr',[['td-data-table-row',
          '']],(null as any),(null as any),(null as any),i18.View_TdDataTableRowComponent_0,
          i18.RenderType_TdDataTableRowComponent)),i1.ɵdid(49152,(null as any),0,i19.TdDataTableRowComponent,
          [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),0,6,'td',[['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n                  '])),(_l()(),i1.ɵeld(0,
          (null as any),0,2,'b',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted(0,['\n                '])),(_l()(),i1.ɵted(0,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i20.View_TdDataTableCellComponent_0,
          i20.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i21.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(0,
          ['\n              '])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'mat-table-container tmp-driven-table';
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = 'duplicated-thead-fix';
    _ck(_v,10,0,currVal_3);
    const currVal_12:any = _co.items;
    _ck(_v,29,0,currVal_12);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_4:any = i1.ɵnov(_v,17).bindClickable;
    const currVal_5:any = i1.ɵnov(_v,17).bingSortable;
    const currVal_6:any = i1.ɵnov(_v,17).bindActive;
    const currVal_7:any = i1.ɵnov(_v,17).bindNumeric;
    _ck(_v,16,0,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = i1.ɵnov(_v,21).bindClickable;
    const currVal_9:any = i1.ɵnov(_v,21).bingSortable;
    const currVal_10:any = i1.ɵnov(_v,21).bindActive;
    const currVal_11:any = i1.ɵnov(_v,21).bindNumeric;
    _ck(_v,20,0,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_13:any = i1.ɵnov(_v,35).bindNumeric;
    _ck(_v,34,0,currVal_13);
    const currVal_14:any = i1.ɵnov(_v,39).bindNumeric;
    _ck(_v,38,0,currVal_14);
    const currVal_15:any = i1.ɵnov(_v,47).bindNumeric;
    _ck(_v,46,0,currVal_15);
    const currVal_16:any = i1.ɵunv(_v,48,0,_ck(_v,49,0,i1.ɵnov((<any>_v.parent),0),
        'total',_co._authService.getLanguage()));
    _ck(_v,48,0,currVal_16);
    const currVal_17:any = i1.ɵnov(_v,52).bindNumeric;
    _ck(_v,51,0,currVal_17);
    const currVal_18:any = i1.ɵunv(_v,53,0,_ck(_v,54,0,i1.ɵnov((<any>_v.parent),1),
        _co.total(),'1.2-2'));
    _ck(_v,53,0,currVal_18);
    const currVal_19:any = i1.ɵnov(_v,61).bindNumeric;
    _ck(_v,60,0,currVal_19);
    const currVal_20:any = i1.ɵunv(_v,62,0,_ck(_v,63,0,i1.ɵnov((<any>_v.parent),0),
        'tax',_co._authService.getLanguage()));
    const currVal_21:any = _co.currentDebitNote.tax;
    _ck(_v,62,0,currVal_20,currVal_21);
    const currVal_22:any = i1.ɵnov(_v,66).bindNumeric;
    _ck(_v,65,0,currVal_22);
    const currVal_23:any = i1.ɵunv(_v,67,0,_ck(_v,68,0,i1.ɵnov((<any>_v.parent),1),
        ((_co.total() * _co.currentDebitNote.tax) / 100),'1.2-2'));
    _ck(_v,67,0,currVal_23);
    const currVal_24:any = i1.ɵnov(_v,75).bindNumeric;
    _ck(_v,74,0,currVal_24);
    const currVal_25:any = i1.ɵunv(_v,76,0,_ck(_v,77,0,i1.ɵnov((<any>_v.parent),0),
        'tax2',_co._authService.getLanguage()));
    const currVal_26:any = _co.currentDebitNote.tax2;
    _ck(_v,76,0,currVal_25,currVal_26);
    const currVal_27:any = i1.ɵnov(_v,80).bindNumeric;
    _ck(_v,79,0,currVal_27);
    const currVal_28:any = i1.ɵunv(_v,81,0,_ck(_v,82,0,i1.ɵnov((<any>_v.parent),1),
        ((_co.total() * _co.currentDebitNote.tax2) / 100),'1.2-2'));
    _ck(_v,81,0,currVal_28);
    const currVal_29:any = i1.ɵnov(_v,89).bindNumeric;
    _ck(_v,88,0,currVal_29);
    const currVal_30:any = i1.ɵunv(_v,92,0,_ck(_v,93,0,i1.ɵnov((<any>_v.parent),0),
        'total',_co._authService.getLanguage()));
    _ck(_v,92,0,currVal_30);
    const currVal_31:any = i1.ɵnov(_v,97).bindNumeric;
    _ck(_v,96,0,currVal_31);
    const currVal_32:any = i1.ɵunv(_v,98,0,_ck(_v,99,0,i1.ɵnov((<any>_v.parent),1),
        (_co.total() * ((1 + (_co.currentDebitNote.tax / 100)) + (_co.currentDebitNote.tax2 / 100))),
        '1.2-2'));
    _ck(_v,98,0,currVal_32);
  });
}
function View_DebitNoteComponent_12(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.createNewDebitNote()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.isLoading();
        const currVal_2:any = 'primary';
        _ck(_v,2,0,currVal_1,currVal_2);
        const currVal_3:any = 'bg-blue color-white';
        _ck(_v,4,0,currVal_3);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
        const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>_v.parent),0),
            'create',_co._authService.getLanguage()));
        _ck(_v,5,0,currVal_4);
      });
}
function View_DebitNoteComponent_13(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.updateDebitNote()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.isLoading();
        const currVal_2:any = 'primary';
        _ck(_v,2,0,currVal_1,currVal_2);
        const currVal_3:any = 'bg-blue color-white';
        _ck(_v,4,0,currVal_3);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
        const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>_v.parent),0),
            'update',_co._authService.getLanguage()));
        _ck(_v,5,0,currVal_4);
      });
}
export function View_DebitNoteComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i26.TranslatePipe,([] as any[])),i1.ɵpid(0,i15.DecimalPipe,
      [i1.LOCALE_ID]),(_l()(),i1.ɵeld(0,(null as any),(null as any),140,'div',[['fxLayout',
      'column']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n  \n\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_DebitNoteComponent_1)),i1.ɵdid(16384,(null as any),0,
          i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          133,'div',[['class','boxed-content-wrapper cards-no-gaps']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_DebitNoteComponent_2)),
      i1.ɵdid(212992,(null as any),0,i27.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
          i28.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],strategy:[3,
          'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),79,'md-card',
          ([] as any[]),[[2,'mat-card',(null as any)]],(null as any),(null as any),
          i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,11,'md-card-header',
          [['fxLayout','column']],[[2,'mat-card-header',(null as any)]],(null as any),
          (null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          ','\n        '])),
      i1.ɵppd(2),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),0,61,'md-card-content',([] as any[]),[[2,'mat-card-content',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),56,'div',
          [['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],
              ['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,41)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,67,{_mdInputChild:0}),i1.ɵqud(335544320,68,{_placeholderChild:0}),
      i1.ɵqud(603979776,69,{_errorChildren:1}),i1.ɵqud(603979776,70,{_hintChildren:1}),
      i1.ɵqud(603979776,71,{_prefixChildren:1}),i1.ɵqud(603979776,72,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i29.DebitNoteComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,51)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,51).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,51)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,51)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,56)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,56)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,56)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.item.description = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[67,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
              '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,61)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,73,{_mdInputChild:0}),i1.ɵqud(335544320,74,{_placeholderChild:0}),
      i1.ɵqud(603979776,75,{_errorChildren:1}),i1.ɵqud(603979776,76,{_hintChildren:1}),
      i1.ɵqud(603979776,77,{_prefixChildren:1}),i1.ɵqud(603979776,78,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i29.DebitNoteComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,71)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,71).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,71)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,71)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,76)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,76)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,76)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.item.price = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[73,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),10,'div',[['fxFlex','22%']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
              ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i29.DebitNoteComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.addItemsToOrder()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          45,'md-card',([] as any[]),[[2,'mat-card',(null as any)]],(null as any),
          (null as any),i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,
          (null as any),0,11,'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',
              (null as any)]],(null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['','\n        '])),i1.ɵppd(2),
      (_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_DebitNoteComponent_10)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),
          i1.ɵeld(0,(null as any),0,24,'md-card-actions',([] as any[]),[[2,'mat-card-actions',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'div',
          [['class','table-control-buttons'],['fxFlex',''],['fxFlexAlign','start'],
              ['fxFlexAlign.lt-md','center'],['fxLayoutGap','12px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [8,(null as any)]],{gap:[0,'gap']},(null as any)),i1.ɵdid(737280,(null as any),
          0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
              [3,i14.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(737280,
          (null as any),0,i30.FlexAlignDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {align:[0,'align'],alignLtMd:[1,'alignLtMd']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DebitNoteComponent_12)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DebitNoteComponent_13)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-red color-white  mat-button'],
          ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i29.DebitNoteComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{disabled:[0,
              'disabled'],color:[1,'color']},(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i29.DebitNoteComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.changed();
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,9,0,currVal_2);
    const currVal_3:any = 'loading';
    const currVal_4:any = 'circle';
    const currVal_5:any = 'indeterminate';
    const currVal_6:any = 'overlay';
    const currVal_7:any = 'accent';
    _ck(_v,12,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_10:any = 'column';
    _ck(_v,21,0,currVal_10);
    const currVal_12:any = 'bg-grey color-white text-only';
    _ck(_v,26,0,currVal_12);
    const currVal_15:any = 'row';
    const currVal_16:any = 'column';
    _ck(_v,36,0,currVal_15,currVal_16);
    const currVal_17:any = '30px';
    const currVal_18:any = '14px';
    _ck(_v,37,0,currVal_17,currVal_18);
    const currVal_19:any = 'padded-container';
    _ck(_v,38,0,currVal_19);
    const currVal_31:any = '47%';
    _ck(_v,48,0,currVal_31);
    const currVal_45:any = _co.item.description;
    _ck(_v,53,0,currVal_45);
    const currVal_46:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,56,0,_ck(_v,57,0,
        i1.ɵnov(_v,0),'description',_co._authService.getLanguage())),'');
    _ck(_v,56,0,currVal_46);
    const currVal_58:any = '22%';
    _ck(_v,68,0,currVal_58);
    const currVal_72:any = _co.item.price;
    _ck(_v,73,0,currVal_72);
    const currVal_73:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,76,0,_ck(_v,77,0,
        i1.ɵnov(_v,0),'price',_co._authService.getLanguage())),'');
    _ck(_v,76,0,currVal_73);
    const currVal_74:any = '22%';
    _ck(_v,81,0,currVal_74);
    const currVal_76:any = 'primary';
    _ck(_v,85,0,currVal_76);
    const currVal_77:any = 'bg-blue color-white';
    _ck(_v,87,0,currVal_77);
    const currVal_81:any = 'column';
    _ck(_v,102,0,currVal_81);
    const currVal_83:any = 'bg-grey color-white text-only';
    _ck(_v,107,0,currVal_83);
    const currVal_85:any = _co.currentDebitNote;
    _ck(_v,113,0,currVal_85);
    const currVal_87:any = '12px';
    _ck(_v,120,0,currVal_87);
    const currVal_88:any = '';
    _ck(_v,121,0,currVal_88);
    const currVal_89:any = 'start';
    const currVal_90:any = 'center';
    _ck(_v,122,0,currVal_89,currVal_90);
    const currVal_91:any = 'table-control-buttons';
    _ck(_v,123,0,currVal_91);
    const currVal_92:boolean = (!_co.isEditMode && !_co._authService.isViewer());
    _ck(_v,126,0,currVal_92);
    const currVal_93:any = (_co.isEditMode && !_co._authService.isViewer());
    _ck(_v,129,0,currVal_93);
    const currVal_95:any = _co.isLoading();
    const currVal_96:any = 'warn';
    _ck(_v,133,0,currVal_95,currVal_96);
    const currVal_97:any = 'bg-red color-white ';
    _ck(_v,135,0,currVal_97);
  },(_ck,_v) => {
    var _co:i29.DebitNoteComponent = _v.component;
    const currVal_8:any = true;
    _ck(_v,14,0,currVal_8);
    const currVal_9:any = true;
    _ck(_v,18,0,currVal_9);
    const currVal_11:any = true;
    _ck(_v,23,0,currVal_11);
    const currVal_13:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov(_v,0),'order_items',
        _co._authService.getLanguage()));
    _ck(_v,27,0,currVal_13);
    const currVal_14:any = true;
    _ck(_v,31,0,currVal_14);
    const currVal_20:any = (null as any);
    const currVal_21:any = true;
    const currVal_22:any = i1.ɵnov(_v,41)._isErrorState();
    const currVal_23:any = i1.ɵnov(_v,41)._mdInputChild.focused;
    const currVal_24:any = i1.ɵnov(_v,41)._shouldForward('untouched');
    const currVal_25:any = i1.ɵnov(_v,41)._shouldForward('touched');
    const currVal_26:any = i1.ɵnov(_v,41)._shouldForward('pristine');
    const currVal_27:any = i1.ɵnov(_v,41)._shouldForward('dirty');
    const currVal_28:any = i1.ɵnov(_v,41)._shouldForward('valid');
    const currVal_29:any = i1.ɵnov(_v,41)._shouldForward('invalid');
    const currVal_30:any = i1.ɵnov(_v,41)._shouldForward('pending');
    _ck(_v,40,1,[currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,
        currVal_26,currVal_27,currVal_28,currVal_29,currVal_30]);
    const currVal_32:any = i1.ɵnov(_v,55).ngClassUntouched;
    const currVal_33:any = i1.ɵnov(_v,55).ngClassTouched;
    const currVal_34:any = i1.ɵnov(_v,55).ngClassPristine;
    const currVal_35:any = i1.ɵnov(_v,55).ngClassDirty;
    const currVal_36:any = i1.ɵnov(_v,55).ngClassValid;
    const currVal_37:any = i1.ɵnov(_v,55).ngClassInvalid;
    const currVal_38:any = i1.ɵnov(_v,55).ngClassPending;
    const currVal_39:any = true;
    const currVal_40:any = i1.ɵnov(_v,56).id;
    const currVal_41:any = i1.ɵnov(_v,56).placeholder;
    const currVal_42:any = i1.ɵnov(_v,56).disabled;
    const currVal_43:any = i1.ɵnov(_v,56).required;
    const currVal_44:any = (i1.ɵnov(_v,56).ariaDescribedby || (null as any));
    _ck(_v,50,1,[currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,
        currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44]);
    const currVal_47:any = (null as any);
    const currVal_48:any = true;
    const currVal_49:any = i1.ɵnov(_v,61)._isErrorState();
    const currVal_50:any = i1.ɵnov(_v,61)._mdInputChild.focused;
    const currVal_51:any = i1.ɵnov(_v,61)._shouldForward('untouched');
    const currVal_52:any = i1.ɵnov(_v,61)._shouldForward('touched');
    const currVal_53:any = i1.ɵnov(_v,61)._shouldForward('pristine');
    const currVal_54:any = i1.ɵnov(_v,61)._shouldForward('dirty');
    const currVal_55:any = i1.ɵnov(_v,61)._shouldForward('valid');
    const currVal_56:any = i1.ɵnov(_v,61)._shouldForward('invalid');
    const currVal_57:any = i1.ɵnov(_v,61)._shouldForward('pending');
    _ck(_v,60,1,[currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,currVal_52,
        currVal_53,currVal_54,currVal_55,currVal_56,currVal_57]);
    const currVal_59:any = i1.ɵnov(_v,75).ngClassUntouched;
    const currVal_60:any = i1.ɵnov(_v,75).ngClassTouched;
    const currVal_61:any = i1.ɵnov(_v,75).ngClassPristine;
    const currVal_62:any = i1.ɵnov(_v,75).ngClassDirty;
    const currVal_63:any = i1.ɵnov(_v,75).ngClassValid;
    const currVal_64:any = i1.ɵnov(_v,75).ngClassInvalid;
    const currVal_65:any = i1.ɵnov(_v,75).ngClassPending;
    const currVal_66:any = true;
    const currVal_67:any = i1.ɵnov(_v,76).id;
    const currVal_68:any = i1.ɵnov(_v,76).placeholder;
    const currVal_69:any = i1.ɵnov(_v,76).disabled;
    const currVal_70:any = i1.ɵnov(_v,76).required;
    const currVal_71:any = (i1.ɵnov(_v,76).ariaDescribedby || (null as any));
    _ck(_v,70,1,[currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,
        currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,currVal_70,currVal_71]);
    const currVal_75:any = (i1.ɵnov(_v,85).disabled || (null as any));
    _ck(_v,83,0,currVal_75);
    const currVal_78:any = i1.ɵunv(_v,88,0,_ck(_v,89,0,i1.ɵnov(_v,0),'add_capital',
        _co._authService.getLanguage()));
    _ck(_v,88,0,currVal_78);
    const currVal_79:any = true;
    _ck(_v,95,0,currVal_79);
    const currVal_80:any = true;
    _ck(_v,99,0,currVal_80);
    const currVal_82:any = true;
    _ck(_v,104,0,currVal_82);
    const currVal_84:any = i1.ɵunv(_v,108,0,_ck(_v,109,0,i1.ɵnov(_v,0),'items',_co._authService.getLanguage()));
    _ck(_v,108,0,currVal_84);
    const currVal_86:any = true;
    _ck(_v,115,0,currVal_86);
    const currVal_94:any = (i1.ɵnov(_v,133).disabled || (null as any));
    _ck(_v,131,0,currVal_94);
    const currVal_98:any = i1.ɵunv(_v,136,0,_ck(_v,137,0,i1.ɵnov(_v,0),'back',_co._authService.getLanguage()));
    _ck(_v,136,0,currVal_98);
  });
}
export function View_DebitNoteComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(16777216,(null as any),(null as any),4,'app-debit-note',
      ([] as any[]),(null as any),(null as any),(null as any),View_DebitNoteComponent_0,
      RenderType_DebitNoteComponent)),i1.ɵprd(512,(null as any),i31.CustomerService,
      i31.CustomerService,[i32.HttpInterceptorService,i33.Http,i34.Utils,i35.Configuration,
          i36.AuthenticationService]),i1.ɵprd(512,(null as any),i37.InvoiceService,
      i37.InvoiceService,[i33.Http,i35.Configuration,i36.AuthenticationService]),i1.ɵprd(512,
      (null as any),i38.ReportService,i38.ReportService,[i33.Http,i35.Configuration,
          i36.AuthenticationService]),i1.ɵdid(245760,(null as any),0,i29.DebitNoteComponent,
      [i39.SalesService,i31.CustomerService,i17.ActivatedRoute,i17.Router,i40.TdDataTableService,
          i28.TdLoadingService,i41.TdDialogService,i42.SettingsService,i37.InvoiceService,
          i1.ViewContainerRef,i43.BranchService,i44.InventoryService,i38.ReportService,
          i45.PoService,i15.Location,i36.AuthenticationService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,4,0);
      },(null as any));
}
export const DebitNoteComponentNgFactory:i1.ComponentFactory<i29.DebitNoteComponent> = i1.ɵccf('app-debit-note',
    i29.DebitNoteComponent,View_DebitNoteComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/sales/debit-note/debit-note.component.ngfactory.ts